export const startupTabs = [
  { to: '/pitches', label: 'Pitches' },
  { to: '/share', label: 'Share' },
] as const

export const investorTabs = [{ to: '/pitches', label: 'Pitches' }] as const

export const adminNavItems = [
  { to: '/admin/evaluations', label: 'Evaluations' },
  { to: '/admin/prescreens', label: 'Pre-screens' },
  { to: '/admin/startups', label: 'Startups' },
  { to: '/admin/investors', label: 'Investors' },
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/datarooms', label: 'Data Rooms' },
  { to: '/admin/feedback', label: 'Feedback' },
  { to: '/admin/onboarding', label: 'Onboarding' },
  { to: '/admin/emails', label: 'Emails' },
] as const
